// extracted by mini-css-extract-plugin
export default {"Dish":"Dish_Dish__OkX-z","DishImage":"Dish_DishImage__mmamQ","DishName":"Dish_DishName__Twz4f","DishPrice":"Dish_DishPrice__OQaDC","DishStock":"Dish_DishStock__KKXQd"};